module.exports = __webpack_public_path__ + "fonts/iconfont.9824a50b.woff";